module.exports = __webpack_public_path__ + "static/img/05.38bcec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/gamify/tutorial/05.svg
// module id = QWrv
// module chunks = 13